// extracted by mini-css-extract-plugin
module.exports = {"root":"LaneMenu_root__2Y2ct","delete":"LaneMenu_delete__28coO"};